import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem, type RichResource } from '@src/services/interface';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { jumpPageUrl, getQuery } from '@src/utils/index';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';

type ForwardFeedProps = {
    content: FeedFlowItem | null | undefined;
};

const ForwardFeed = ({ content }: ForwardFeedProps) => {
    const forwardItem = content;
    const faceUrl = forwardItem?.author?.avatar;
    const userName = forwardItem?.author?.nickname;
    const richResource: RichResource = forwardItem?.richResource && JSON.parse(forwardItem?.richResource);

    const imageUrl =
        richResource?.imageList?.[0]?.url ||
        richResource?.imageList?.[0]?.intranetUrl ||
        richResource?.videoList?.[0]?.posterImg;
    const isReveal = forwardItem?.unlock;
    const guid = forwardItem?.guid || '';
    const id = forwardItem?.id || '';
    let title = forwardItem?.title;
    const postLinkTitle = forwardItem?.post?.link?.title || '';
    // @ts-ignore
    const postLinkUrl = forwardItem?.post?.link?.shareUrl || content?.post?.link?.url || '';
    let hasImage = true;
    let isShow = true;
    let markText = '';
    const hasVideo = forwardItem?.post?.hasVideo ?? false;
    const type = forwardItem?.type;

    if (type === 'predict') {
        markText = '预言';
        title = forwardItem?.title || forwardItem?.summary;
        if (!isReveal) {
            hasImage = false;
        }

        if (forwardItem?.useFlag === 0) {
            isShow = false;
        }
    }

    if (type === 'translate') {
        markText = '编译';
    }

    const jumpHandle = () => {
        const userId = getQuery(window.location.href, 'userId') || '';

        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'a',
            user_id: userId,
        });
        jumpPageUrl('personal', guid);
    };

    return isShow ? (
        <div className={styles.articleProphesy}>
            <div className={styles.head} onClick={jumpHandle}>
                {faceUrl && <img className={styles.face} src={formatImageWebpAuto(faceUrl, 40, 40)} />}
                {userName && <div className={styles.username}>{userName}</div>}
                {markText && <div className={styles.mark}>发布了一篇{markText}</div>}
            </div>
            <div
                className={styles.feed}
                onClick={() => {
                    jumpPageUrl('article', id);
                }}>
                {hasImage && imageUrl && (
                    <div className={styles.picBox}>
                        <img className={styles.pic} src={formatImageWebpAuto(imageUrl, 90, 90)} />
                        {hasVideo && <div className={styles.videoIcon} />}
                    </div>
                )}
                {title && <div className={styles.text}>{title}</div>}
            </div>
            {postLinkTitle && (
                <div
                    onClick={() => {
                        window.location.href = postLinkUrl;
                    }}
                    className={styles.link}>
                    {postLinkTitle}
                </div>
            )}
        </div>
    ) : null;
};

export default errorBoundary(ForwardFeed);
